export function MasterInit() {
	// const {config} = useLayout();
	// const isFirstRun = useRef(true);
	// const pluginsInitialization = () => {
	// 	isFirstRun.current = false;
	// 	// ThemeModeComponent.init();
	// 	// setTimeout(() => {
	// 	// 	ToggleComponent.bootstrap();
	// 	// 	ScrollTopComponent.bootstrap();
	// 	// 	DrawerComponent.bootstrap();
	// 	// 	StickyComponent.bootstrap();
	// 	// 	MenuComponent.bootstrap();
	// 	// 	ScrollComponent.bootstrap();
	// 	// 	SwapperComponent.bootstrap();
	// 	// 	document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
	// 	// 		Tab.getOrCreateInstance(tab);
	// 	// 	});
	// 	// }, 500);
	// };

	// useEffect(() => {
	// 	if (isFirstRun.current) {
	// 		isFirstRun.current = false;
	// 		pluginsInitialization();
	// 	}
	// }, [config]);

	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <></>;
}
